import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Flex, Text, rem, Box } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAtom } from "jotai";

import { Loader } from "components";
import { ConfirmationSkeleton } from "components/skeletons";
import EventInfoCard from "views/TicketBooking/EventInfoCard";
import { updatestate } from "store/reducer";
import { totalAmount } from "store/atoms";

import {
  useGetEventDetailsQuery,
  useGetBookingInfoQuery,
} from "store/services/ticketServices";
import {
  REDUX_STATE,
  ADD_PARTICIPANT_BODY,
  SEND_EMAIL_CONFIRMATION_DATA,
  TOTAL_PRICE,
} from "constants";

import {
  LocationIcon,
  TimerIcon,
  ShareIcon,
  CheckIcon,
  ChevronsIconLeft,
} from "assets/icon";
import useStyles from "components/useFormStyles";
import { TwAppBar, TwButton, TwFooter } from "components/tailwind";
import { resetReservationstate } from "store/reducer/ticketReservationSlice";
import { BOOKINK_LINK } from "constants";
import { SELLER_REF } from "constants";
import { CAMPAIGN_REF } from "constants";
import { TRACK_TOKEN } from "constants";
import { useTranslation } from "react-i18next";

function OrderConfirmation() {
  const { t } = useTranslation();
  const BOOKINKLINK = window.localStorage.getItem(BOOKINK_LINK);
  const sellerRef = window.localStorage.getItem(SELLER_REF);
  const campaignRef = window.localStorage.getItem(CAMPAIGN_REF);
  const trackToken = window.localStorage.getItem(TRACK_TOKEN);
  // Attribution query for re-entry links. Prefer the opaque token; fall back to
  // legacy ?ref=<seller>&c=<campaign> for old links without a token.
  const attributionQuery =
    trackToken && trackToken !== ""
      ? `?t=${trackToken}`
      : sellerRef && sellerRef !== ""
        ? `?ref=${sellerRef}${campaignRef && campaignRef !== "" ? `&c=${campaignRef}` : ""}`
        : "";
  const { eventName, refId, bookingId } = useParams();

  const { data: eventData, isFetching: isFetchingEventData } =
    useGetEventDetailsQuery({ name: eventName, refId });
  const { data: bookingInfo, isFetching: isFetchingBookingInfo } =
    useGetBookingInfoQuery(bookingId);

  const { classes } = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [, setTotalPrice] = useAtom(totalAmount);

  // console.log("bookingconfirmed...", bookingconfirmed);

  useEffect(() => {
    dispatch(
      updatestate({
        reservationId: undefined,
        selectedPaymentMethod: null,
        idealBank: null,
        selectedEventPricing: null,
        addonsPricingList: null,
      })
    );

    let reduxstateFromStorage = window.localStorage.getItem(REDUX_STATE);
    reduxstateFromStorage = reduxstateFromStorage
      ? JSON.parse(reduxstateFromStorage)
      : {};

    delete reduxstateFromStorage.reservationId;
    delete reduxstateFromStorage.selectedPaymentMethod;
    if (reduxstateFromStorage.idealBank) {
      delete reduxstateFromStorage.idealBank;
    }
    delete reduxstateFromStorage.selectedEventPricing;
    delete reduxstateFromStorage.addonsPricingList;

    window.localStorage.setItem(
      REDUX_STATE,
      JSON.stringify(reduxstateFromStorage)
    );

    // Clean up transient booking data
    window.localStorage.removeItem(ADD_PARTICIPANT_BODY);
    window.localStorage.removeItem(SEND_EMAIL_CONFIRMATION_DATA);
    window.localStorage.removeItem(TOTAL_PRICE);

    setTotalPrice(0);
  }, [dispatch]);

  const onBack = () => {
    if (BOOKINKLINK && BOOKINKLINK !== "") {
      // BOOKINK_LINK already carries ?ref=<seller>&c=<campaign> — use it as-is.
      navigate(BOOKINKLINK, { replace: true });
    } else {
      navigate(`/${eventName}/${refId}${attributionQuery}`, { replace: true });
    }
    window.location.reload();
  };

  useEffect(() => {
    dispatch(resetReservationstate());
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      onBack();
      return;
    };
    // window.addEventListener("popstate", function (event) {
    //   console.log("Back button clicked");
    //   alert("addEventListener back")
    //   // Custom logic here
    // });
    // window.onbeforeunload = (e) => {
    //   e.preventDefault();

    //   alert("onbeforeunload")
    //   e.returnValue = ''; // Show browser-native confirmation dialog
    // };
  }, []);
  if (isFetchingEventData || isFetchingBookingInfo) {
    return <ConfirmationSkeleton />;
  }

  return (
    <div className="w-full max-w-md h-screen flex flex-col">
      <TwAppBar
        isBackBtnShow={true}
        onBackClick={onBack}
        title={t("order.confirmation")}
      />
      <div className="flex-1 flex flex-col gap-4 justify-center items-center bg-white">
        <div className="flex flex-col justify-center items-center gap-2 p-4">
          <img src="/images/success.svg" alt="" className="" />
          <div className="text-lg font-bold my-3">{t("order.confirmed")}</div>
          <div className="text-sm">{t("order.detailsSent")}</div>
          <div className="text-sm text-secondary font-bold">
            {bookingInfo?.data?.consumer_detail?.email}
          </div>
        </div>
        {/* Ticket Info*/}
        {/* <EventInfoCard
              reduxstate={{
                eventData: eventData?.data,
                location: eventData?.data?.location,
                eventDate: eventData?.data?.eventDate,
                eventEndDate: eventData?.data?.eventEndDate,
              }}
              selectedStep={5}
              isReadMore={false}
              isReview={true}
              toggleReadMore={() => {}}
            /> */}
        <div className="w-full p-4">
          {false && (<>
            {bookingInfo?.data?.amount === 0 ? (
              <div className="title-free font-bold mb-3">Free Event</div>
            ) : bookingInfo?.data?.paymentStatus === "Unpaid" ? (
              <div className="font-bold mb-3">Payments Due</div>
            ) : (
              <div className="flex justify-center gap-2 font-bold mb-3">
                Payment Confirmed
                <div className="bg-green-800 text-white rounded-full">
                  <CheckIcon w="24" h="24" />
                </div>
              </div>
            )}
            <div className="ticks">
              <Box
                px={rem(8)}
                py={rem(4)}
                bg="grape.9"
                sx={{ borderRadius: rem(10) }}
              >
                <Text fz={14} fw={600} c="white">
                  Tickets
                </Text>
              </Box>
              {bookingInfo?.data?.ticketsBought?.map((item, index) => {
                // const absorbServiceFee = item?.absorbServiceFee || false;

                return (
                  <Flex
                    key={`${index}-ticket`}
                    direction="row"
                    justify="space-between"
                    align="center"
                    my={4}
                  >
                    <Flex direction="column">
                      <Text fz={14} fw={600}>
                        {item?.ticketType}
                      </Text>
                      <Text fz={13} fw={400} c="gray">
                        {item?.bookingQty} X €
                        {parseFloat(item.ticketAmount) +
                          (item.absorbServiceFee
                            ? 0
                            : parseFloat(
                              parseFloat(item.serviceFee) /
                              parseFloat(item.bookingQty)
                            ))}
                      </Text>
                    </Flex>
                    <Flex direction="column">
                      <Text fz={14} fw={600} align="right">
                        €{item?.totalPrice.toFixed(2)}
                      </Text>
                    </Flex>
                  </Flex>
                );
              })}
              {bookingInfo?.data?.addonsBought?.length > 0 && (
                <div>
                  <Box
                    mt={rem(16)}
                    px={rem(8)}
                    py={rem(4)}
                    bg="grape.9"
                    sx={{ borderRadius: rem(10) }}
                  >
                    <Text fz={14} fw={600} c="white">
                      Add-ons
                    </Text>
                  </Box>
                  {bookingInfo?.data?.addonsBought?.map((item, index) => {
                    return (
                      <Flex
                        key={`${index}-addon`}
                        direction="row"
                        justify="space-between"
                        align="center"
                        my={4}
                      >
                        <Flex direction="column">
                          <Text fz={14} fw={600}>
                            {item?.addonName}
                          </Text>
                          <Text fz={13} fw={400} c="gray">
                            {item?.bookingQty} X €
                            {item?.ticketAmount +
                              (item?.serviceFee ? item?.serviceFee : 0)}
                          </Text>
                        </Flex>
                        <Flex direction="column">
                          <Text fz={14} fw={600} align="right">
                            €{item?.totalPrice.toFixed(2)}
                          </Text>
                        </Flex>
                      </Flex>
                    );
                  })}
                </div>
              )}
              <Flex
                justify="space-between"
                align="center"
                direction="row"
                mt={rem(16)}
              >
                <Text fz={rem(15)} fw="600">
                  Processing fee
                </Text>
                <Text fz={rem(15)} fw="600">
                  €{bookingInfo?.data?.totalPaymentServiceFee}
                </Text>
              </Flex>
            </div>
            <Flex
              direction="row"
              justify="space-between"
              align="center"
              bg="#F4F4F4"
              p={12}
              style={{ borderRadius: 10 }}
            >
              <Text fz="lg">{t("order.totalVat")}</Text>
              <Text fw={500} fz="lg">
                €{Number(bookingInfo?.data?.totalStripeAmount).toFixed(2)}
              </Text>
            </Flex>
            {/* <div className="total">
                <div className="text">{`Total (incl. tax & €${bookingInfo?.data?.totalPaymentServiceFee} processing Fee)`}</div>
                <div className="price">
                  €{Number(bookingInfo?.data?.totalStripeAmount).toFixed(2)}
                </div>
              </div> */}
            {bookingInfo?.data?.paymentStatus === "Unpaid" && (
              <div className="notice">
                Host may send you a payment request before start of the event
              </div>
            )}
          </>)}
          <div className="flex flex-col gap-4">
            <TwButton
              // className={classes.downloadBtn}
              onClick={() => {
                // window.open(bookingInfo?.data?.tickets?.[0]?.downloadUrl, '_blank').focus();
                window.open(bookingInfo?.data?.manageBookingUrl, '_blank').focus();
              }}
            // href={bookingInfo?.data?.tickets?.[0]?.downloadUrl}
            // target="_blank"
            >
              {t("order.downloadTicket")}
            </TwButton>
            <TwButton
              // className={classes.submit}
              variant={"primary-outline"}
              component="a"
              onClick={() => {
                window.open(`${eventData?.data?.bookingLink}${attributionQuery}`, '_blank').focus();

              }}
            // href={`${eventData?.data?.bookingLink}`}
            // target="_blank"
            >
              {t("order.bookAgain")}
            </TwButton>
          </div>
        </div>

        {/* <div className="section share-blk">
            <button className="button-primary">
              Share <ShareIcon />
            </button>
          </div> */}
      </div>
      <TwFooter></TwFooter>
    </div>
  );
}

export default OrderConfirmation;
